import { render, staticRenderFns } from "./naira-icon.vue?vue&type=template&id=50e0eed4"
import script from "./naira-icon.vue?vue&type=script&lang=js"
export * from "./naira-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports